module.exports = __webpack_public_path__ + "media/images/salary-f4dfbf95.png";